import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { PerspectiveCamera } from './PerspectiveCamera.js';

var ArrayCamera = /*#__PURE__*/function (_PerspectiveCamera) {
  _inheritsLoose(ArrayCamera, _PerspectiveCamera);

  function ArrayCamera(array) {
    var _this;

    if (array === void 0) {
      array = [];
    }

    _this = _PerspectiveCamera.call(this) || this;
    _this.cameras = array;
    return _this;
  }

  return ArrayCamera;
}(PerspectiveCamera);

ArrayCamera.prototype.isArrayCamera = true;
export { ArrayCamera };